<template>
  <b-container>
    <div class="my-job-page page">
      <div class="page__header">
        <h2>My Tools</h2>
      </div>
      <div class="page__card page__card--full page__card--no-bg mt-0">
        <job-list class="my-job-page__list" />
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * My Tools/Jobs page
 * ==================================================================================
 **/

import JobList from '@/components/lists/JobList'

export default {
  metaInfo: function() {
    return {
      title: 'My Tools'
    }
  },
  components: {
    JobList
  }
}
</script>
<style scoped lang="scss">
.my-job-page {
  .page__header {
    padding-bottom: 25px;
  }
}
</style>
